export function XCircle2Icon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M8.00025 14.6666C11.6822 14.6666 14.6669 11.6818 14.6669 7.99992C14.6669 4.31802 11.6822 1.33325 8.00025 1.33325C4.31836 1.33325 1.33359 4.31802 1.33359 7.99992C1.33359 11.6818 4.31836 14.6666 8.00025 14.6666Z" fill="currentColor" />
      <path d="M10 6L6 10M6 6L10 10" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}

XCircle2Icon.displayName = 'XCircle2Icon';
